import { render, staticRenderFns } from "./UserYearScore.vue?vue&type=template&id=37b07677&scoped=true"
import script from "./UserYearScore.vue?vue&type=script&lang=js"
export * from "./UserYearScore.vue?vue&type=script&lang=js"
import style0 from "./UserYearScore.vue?vue&type=style&index=0&id=37b07677&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b07677",
  null
  
)

export default component.exports